<template>
  <ECharts :options="pieOptions" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/legendScroll';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';

@Component({
  components: { ECharts }
})
export default class PieEchart extends Vue {
  @Prop(Object) options;
  @Prop(String) titleText;
  @Prop(Object) data;

  defaultColor = [
    '#E87C25', '#9BCA63', '#9d9a7a', '#F3A43B', '#60C0DD', '#D7504B',
    '#4e8164', '#F4E001', '#F0805A', '#26C0C0', '#b77464', '#5db5dd',
    '#8654aa', '#a47ac3', '#ba99d3', '#d399ce', '#a490a2', '#8d788b',
    '#8b6c60', '#c3aaa0', '#a47f4f', '#957d5e', '#a0aa4f', '#8f955e',
    '#FE8463', '#B5C334', '#27727B', '#c6a84e', '#4e99c6', '#4ec682'
  ]

  // 一个分类对应一种颜色
  getCategoryColor(name) {
    const colorLength = this.defaultColor.length;
    const index = this.options.categoryNames.indexOf(name);
    return this.defaultColor[(index + 1) % colorLength];
  }

  categoryColors(data) {
    return _.map(data, (item) => this.getCategoryColor(item.name));
  }

  get pieOptions() {
    const data = this.data;
    let color = this.options.categoryNames ? this.categoryColors(data) : this.defaultColor;
    let options = {
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
      },
      title: {
        text: this.titleText,
        left: '0',
        top: '5%',
        textStyle: {
          color: '#303133'
        }
      },
      legend: {
        type: 'scroll',
        orient: 'vertical',
        right: 10,
        top: 20,
        bottom: 20,
        data: _.map(data, (item) => item.name)
      },
      series: [
        {
          name: this.options['seriesName'],
          type: 'pie',
          radius: this.options['seriesRadius'],
          center: this.options['seriesCenter'],
          data: data,
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            },
          }
        }
      ],
      color: color
    };

    if (Object.keys(data || {}).length === 0) {
      options = Object.assign(options, {
        graphic: [
          {
            type: 'text',
            z: 100,
            left: 'center',
            top: 'middle',
            style: {
              fill: '#86888b',
              text: this.$t('noData'),
              font: '14px fangsong'
            }
          }
        ]
      });
    }
    return options;
  }
}
</script>
